import { Stack } from 'expo-router';

export default function RoleManagementLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false
      }}
    >
      <Stack.Screen name={'index'} />
      <Stack.Screen name={'[id]'} />
    </Stack>
  );
}
